<template>
  <router-link tag="div" class="my-card" style="cursor: pointer;" :to="link" v-if="link != ''">
    <h2 class="name--my-card text-center">{{ sessionName }}</h2>
    <v-img
        v-if="imgName"
        :src="require(`../assets/${imgName}.png`)"
        max-width="90"
        max-height="90">
    </v-img>
    <v-icon v-else size="90" :color="colorIcon">{{iconName}}</v-icon>
    <p class="text--my-card text-center font-weight-bold">{{ info }}</p>
  </router-link>
  <div class="my-card" v-else>
    <h2 class="name--my-card text-center">{{ sessionName }}</h2>
    <v-img
        v-if="imgName"
        :src="require(`../assets/${imgName}.png`)"
        max-width="90"
        max-height="90">
    </v-img>
    <v-icon v-else size="90" :color="colorIcon">{{iconName}}</v-icon>
    <p class="text--my-card text-center font-weight-bold">{{ info }}</p>
  </div>
</template>

<script>
export default {
  props: {
    sessionName: String,
    iconName: String,
    info: String | Number,
    colorIcon: String,
    imgName: String,
    link: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.my-card {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  min-height: 250px;
  padding: 10px;
  background-color: var(--v-gray-lighten5);
  border-radius: 8px;
}

.name--my-card {
  color: var(--v-primary-base);
  font-size: 28px;
}

.text--my-card {
  min-width: 80%;
  margin: 0;
  padding: 8px 25px;
  border-radius: 20px;
  background-color: var(--v-white-base);
  font-size: 16px;
}
</style>
